@if (item(); as current) {
  <button
    [class.is-urgent]="current.urgent"
    [class.is-live]="current.state === 'live'"
    type="button"
    class="countdown-bar countdown-bar--collapsed"
    (click)="expand.emit()"
  >
    <span class="countdown-bar__top-inner">
      <bingo-countdown-bar-header [item]="current" [collapsed]="true" />
    </span>
  </button>
}
